import ManagerInfoCardPresenter from "./ManagerInfoCardPresenter";

const ManagerInfoCard = ManagerInfoCardPresenter

export default ManagerInfoCard